import { createContext, useState } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';

export interface DrawerContextValue {
  drawerOpen: boolean,
  openDrawer: () => void;
  closeDrawer: () => void;
  openDrawerInButton: () => void;
  closeDrawerInButton: () => void;
}

interface DrawerProviderProps {
  children?: ReactNode;
}

const DrawerContext = createContext<DrawerContextValue>({
  drawerOpen: true,
  openDrawer: () => { },
  closeDrawer: () => { },
  openDrawerInButton: () => { },
  closeDrawerInButton: () => { },
});

export const DrawerProvider: FC<DrawerProviderProps> = (props) => {
  const { children } = props;
  const [drawerOpen, setDrawer] = useState(true);

  const openDrawer = (): void => {
    setDrawer(true);
  };
  const closeDrawer = (): void => {
    setDrawer(false);
  };
  const openDrawerInButton = (): void => {
    setDrawer(false);
  };
  const closeDrawerInButton = (): void => {
    setDrawer(true);
  };

  return (
    <DrawerContext.Provider
      value={{
        drawerOpen,
        openDrawer,
        closeDrawer,
        openDrawerInButton,
        closeDrawerInButton
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const DrawerConsumer = DrawerContext.Consumer;

export default DrawerContext;
